// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__1-nz5","errorLogs":"styles_errorLogs__2z-Vx"};